import React from "react";
import { useTranslation } from "react-i18next";
import { heroImages } from "../data/mock";
import { useTrips } from "../i18n/content";
import { PageHero, TripCard, Reveal, SectionTitle, CTASection } from "../components/common";
import { Check } from "lucide-react";
import Seo from "../components/Seo";

const Trips = () => {
  const { t } = useTranslation();
  const trips = useTrips();
  const included = t("tripsPage.included", { returnObjects: true }) || [];
  return (
    <>
      <Seo
        title="Fishing Trips & Pricing — San Juan del Sur, Nicaragua | Hog Tide"
        description="Half day, full day offshore, surf drops & sunset cruises in San Juan del Sur, Nicaragua. Private charters up to 12 guests from $490. Book your Hog Tide adventure."
        path="/trips"
      />
      <PageHero image={heroImages[1].img} eyebrow={t("tripsPage.heroEyebrow")} title={t("tripsPage.heroTitle")} sub={t("tripsPage.heroSub")} />
      <section className="py-16">
        <div className="container-x">
          <p className="text-slate-300 max-w-3xl mb-10">{t("tripsPage.intro")}</p>
          <div className="grid gap-6 sm:grid-cols-2 lg:grid-cols-2 xl:grid-cols-4">
            {trips.map((t2, i) => (
              <Reveal key={t2.slug} delay={i * 0.08}><TripCard trip={t2} /></Reveal>
            ))}
          </div>
        </div>
      </section>
      <section className="py-6">
        <div className="container-x">
          <SectionTitle center eyebrow={t("tripsPage.includedEyebrow")} title={t("tripsPage.includedTitle")} />
          <div className="grid gap-4 sm:grid-cols-2 lg:grid-cols-3 max-w-4xl mx-auto">
            {(Array.isArray(included) ? included : []).map((f) => (
              <div key={f} className="flex items-center gap-3 rounded-xl bg-[#0e2740] border border-white/10 px-4 py-3">
                <Check className="h-5 w-5 text-[#f5a524] shrink-0" />
                <span className="text-sm text-slate-200">{f}</span>
              </div>
            ))}
          </div>
        </div>
      </section>
      <CTASection image={heroImages[3].img} />
    </>
  );
};

export default Trips;
